var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 19 11","fill":"#2F2F2F","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.707.293l1.414 1.414-8.707 8.707L.707 1.707 2.121.293l7.293 7.293L16.707.293z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }